"use client";
import { Link } from "react-router-dom";
import { getCurrentUser } from "../../lib/auth_base/auth-service";
import useFetchCategories from "../../lib/hooks/use-fetch-categories";
import useFetchProducts from "../../lib/hooks/use-fetch-products";
import ProductList from "../../components/all-products";

export default function ProductsList() {

  const user = getCurrentUser();
  const categories = useFetchCategories();
  const {products:list } = useFetchProducts({limit:100,offset:0,mode:"all"}); 
console.log("products list: ", list);
  return (
    <>

     <div className="dashboard-page-title">
        <div className="breadcrumbs">
          <Link to="/admin">Dashboard</Link>
          <span>Products</span>
        </div>
      </div>
      
      <div className="dashboard-page-content">
        <div className="flex flex-row align-items-center mb10">
          <span className="group-btn">
          </span>
          <span className="spacer align-items-center justify-content-center">
            -
          </span>
          <span className="group-btn">
            <Link to="/admin/products/new">
              New <span className="sm-hide px5">Product</span>
            </Link>
            <Link to="/admin/products/newcategory">
              New Cat<span className="sm-hide">egory</span>
            </Link>
          </span>
        </div>
        <div className="page-body">
          <ProductList
            is_admin={true}
            products={list}
            categories={categories}
            is_logged={user ? true : false}
            user={user}
          />
        </div>
      </div>
    </>
  );
}
